// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","logo":"Logo_logo__Lv6bZ","logo-img":"Logo_logo-img__wZiZW","logo-text":"Logo_logo-text__zlX2D"};